import React from 'react';
import { useTranslation } from 'react-i18next';
import GeneralBtn from './GeneralBtn';

const CancelBtn = ({ href, ...rest }) => {
  const { t } = useTranslation();
  return <GeneralBtn text={t('features.EmployeeBonus.components.ActionButtonSection.cancel')} as="a" href={href} {...rest} />;
};

export default CancelBtn;
